/**
 * This is a wrapper component for different Layouts. Main content should be added to this wrapper.
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './LayoutWrapperMain.global.scss';
import '../../assets/styles/adminBrand.scss';
import { LayoutWrapperTopbar } from '..';
import TopbarContainer from '../../modules/TopbarContainer';

const LayoutWrapperMain = (props: any) => {
  const { className, rootClassName, children } = props;
  const classes = classNames(rootClassName || 'root', className);

  return (
    <div className={`${classes} avatus-workspace`}>
      <div className="content">
        <div>
          <LayoutWrapperTopbar>
            <TopbarContainer />
          </LayoutWrapperTopbar>
          <div className="contentWrapper">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

const { node, string } = PropTypes;

LayoutWrapperMain.propTypes = {
  children: node.isRequired,
  className: string,
  rootClassName: string,
};

export default LayoutWrapperMain;
